import { createSelector } from 'redux-orm';
import { orm } from 'model';

export const selector = createSelector(orm.Org);

export const selectorCount = createSelector(orm, ({ Org }) => Org.count());
